import { PaginatedResponse, Schemas } from "../_app/api/types";
import { Modify } from "../_app/utils/types";
import { ParamsWithQueryFilters } from "../filter/types";

export interface ServiceSetting {
  id: string;
  description: string;
  value: string;
}

export type Asset = Modify<
  Schemas["AssetDTO"],
  { productType: "Mobile" | "Fixed Line"; status: "Live" | "Terminated" | "Disconnected" }
>;

export type MobileAsset = Schemas["MobileAssetWithEligibilityDto"];

export type MobileDetails = Schemas["MobileDetails"];

export type MobileNetwork = "VODAFONE" | "O2";

export type AssetOperationHistory = Modify<Schemas["MobileManagementHistoryDTO"], { status: "FAILED" | "PENDING" | "COMPLETE" }>;

export type GetAssetsOperationHistoryResponse = PaginatedResponse<AssetOperationHistory>;

export type BillLimit = Schemas["HubBillLimitDTO"];

export type GetMobileAssetsResponse = PaginatedResponse<MobileAsset>;

export type GetAssetsResponse = PaginatedResponse<Asset>;

export type SearchAsset = Schemas["AssetOptionInfoDto"];

export type GetClisResponse = string[];

export type GetBillLimitResponse = PaginatedResponse<BillLimit>;

export type BillLimitPrefs = Schemas["BillLimitNotificationPreferencesDTO"];

export type GetBillLimitPrefsResponse = BillLimitPrefs;

export type UpdateBillLimitPrefsParams = Schemas["AssetOperationDTOBillLimitNotificationPrefUpdateDTO"];

export type Address = Schemas["DeliveryAddressDTO"];

export type LineTestResponse = Schemas["LineTestResultDTO"];

export type UpdateBillLimitParams = ParamsWithQueryFilters<Schemas["AssetOperationDTOBillLimitDTO"]>;

export enum BillLimitValidity {
  CURRENT,
  NEXT_MONTH,
}

export type ClearBillLimitParams = ParamsWithQueryFilters<Schemas["AssetSelectorDTO"]>;
